import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import React, { FC, RefObject } from "react";
import useLocalization from "../../hooks/useLocalization";
import { IBook, IParent } from "../../types";
import DialogFooter from "./DialogFooter";

interface IProps {
    book: IBook;
    onCancel: () => void;
    onSave: () => void;
    onDelete: () => void;
    initialFocusRef?: RefObject<HTMLInputElement>;
}

type Props = IParent<React.ReactNode> & IProps;

const DialogWrapper: FC<Props> = (props: Props) => {
    const { uiText } = useLocalization();

    return (
        <Modal
            isOpen={true}
            onClose={props.onCancel}
            size="5xl"
            initialFocusRef={props.initialFocusRef}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {uiText.get("pub-edit-dialog.title")}
                </ModalHeader>

                <ModalCloseButton />

                <ModalBody>
                    {props.children}
                </ModalBody>

                <ModalFooter>
                    <DialogFooter {...props} />
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DialogWrapper;
